import { Button } from '@massilia/ui'
import { FileText } from 'lucide-react'

interface BookingBottomActionsProps {
  onCancel: () => void
  onModify: () => void
}

/**
 * Empilés et pleine largeur sur téléphone : à trois boutons sur une ligne
 * enroulée, chacun tombait sur deux lignes de texte et la cible tactile devenait
 * un pavé de quelques millimètres.
 */
export function BookingBottomActions({ onCancel, onModify }: BookingBottomActionsProps) {
  return (
    <div className="flex flex-col gap-3 sm:flex-row sm:flex-wrap">
      <Button className="w-full text-sm sm:w-auto sm:text-sm" onClick={onModify} type="button">
        Modifier ma réservation
      </Button>
      <Button
        onClick={() => window.open('https://www.traveldoc.aero/fr/')}
        className="w-full text-sm sm:w-auto"
        type="button"
        variant="outline"
      >
        <FileText className="size-4" />
        Conditions d&apos;entrée dans le pays
      </Button>
      <Button
        className="w-full border-red-300 text-sm text-red-600 hover:bg-red-50 sm:w-auto"
        onClick={onCancel}
        type="button"
        variant="outline"
      >
        Annuler mon voyage
      </Button>
    </div>
  )
}
